import { Availability, Category, DateUtils, Id } from '@eo-storefronts/eo-core'

const findCategoryByName = (name: string, categories: Record<Id, Category>): Category | undefined => {
  return Object.values(categories).find(
    (category: Category) => Object.values(category.name).includes(decodeURIComponent(name))
  )
}

const checkCategoryAvailability = (categoryId: Id | null, categories: Record<Id, Category>, time: Date): boolean => {
  if (!categoryId) {
    return true
  }

  const category = categories[categoryId]

  if (!category) {
    return false
  }

  if (category.availabilities?.length > 0) {
    const availabilities = category.availabilities.filter((a) => a.day_id === DateUtils.getDayIdLikeMomentJs(time))

    if (!availabilities.length) {
      return false
    }

    const timeBetween =  availabilities.reduce(
      (status: boolean, availability: Availability) => {
        return status || DateUtils.timeIsBetween(
          DateUtils.formatTime(time),
          {
            start: availability.from_time,
            end: availability.to_time
          }
        )
      },
      false
    )

    if (!timeBetween) {
      return false
    }
  }

  if (category.parent_id !== null) {
    return checkCategoryAvailability(category.parent_id, categories, time)
  }

  return true
}

export {
  findCategoryByName,
  checkCategoryAvailability
}
